import React from "react";
import LoginForm from "@/components/LoginForm";

export default function AdminLogin() {
  return (
    <LoginForm
      title="Administration boutique"
      subtitle="Connecte-toi avec un compte du Bureau disposant de l'accès Boutique."
      onSuccess={() => window.location.reload()}
    />
  );
}
